import { Component, Input, OnInit } from '@angular/core';
import {
  Aangifte,
  AangifteBerekening,
  AangifteRapport,
  BokkzAlgDataService,
  Box3Berekening,
  IncomeTaxEntity,
  OpbouwBelastingBox3,
  SpecificatieBelastingBox3,
  Wetgeving
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule, DecimalPipe } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-belasting-box3',
  templateUrl: './spec-belasting-box3.component.html',
  imports: [
    SharedUiFormControlsModule,
    DecimalPipe,
    CommonModule
  ],
  styleUrls: ['./spec-belasting-box3.component.scss']
})
export class SpecBelastingBox3Component implements OnInit {
  @Input() public id!: string;
  public aangifte = {} as Aangifte;
  public incomeTaxEntity = {} as IncomeTaxEntity;

  @Input() partner = new BehaviorSubject<boolean>(false);
  public partnerBoolean = false;
  private partnerAangifte = {} as Aangifte;

  berekeningFormGroup = this.fb.group<AangifteBerekening>({});
  berekening = {} as AangifteBerekening;
  aangeverBerekening = {} as AangifteBerekening;
  partnerBerekening = {} as AangifteBerekening;
  specBelastingBox3FormGroup = this.fb.group<AangifteRapport>({});
  specBelastingBox3 = {} as AangifteRapport;
  public wetgevingFg = this.fb.group<Wetgeving>({});

  constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
    this.berekeningFormGroup = this.fb.group<AangifteBerekening>(({
      box3: this.fb.group<Box3Berekening>(({
        inkomen: null as unknown as number,
        persoonsgebondenAftrek: null as unknown as number,
        belastbaarInkomen: null as unknown as number,
        inkomstenbelasting: null as unknown as number
      } as Box3Berekening))
    } as AangifteBerekening));
    this.specBelastingBox3FormGroup = this.fb.group<AangifteRapport>(({
      specificatieBelastingBox3: this.fb.group<SpecificatieBelastingBox3>(({
        opbouw: this.fb.group<OpbouwBelastingBox3>(({
          box3VoorVoorkoming: null as unknown as number,
          verrekeningBuitenlandseBronheffing: null as unknown as number,
          vrijstellingBuitenlandsVermogen: null as unknown as number,
          berekendeIB: null as unknown as number
        } as OpbouwBelastingBox3))
      } as SpecificatieBelastingBox3))
    } as AangifteRapport));
    this.wetgevingFg = this.fb.group<Wetgeving>({
      box3Percentage: 36
    });
  }

  getWetgeving() {
    if (this.incomeTaxEntity.aangifte?.aangifteJaar === 2024 || this.incomeTaxEntity.aangifte?.aangifteJaar === 2025 || this.incomeTaxEntity.aangifte?.aangifteJaar === 2026) {
      this.wetgevingFg.get('box3Percentage')?.patchValue(36);
    }
  }

  public ngOnInit(): void {
    combineLatest([this.dataService.incomeTaxEntity,
      this.dataService.aangifteBerekening,
      this.dataService.aangifteRapport,
      this.dataService.partnerAangifteRapport,
    ]).subscribe(
        ([incomeTaxEntity, berekening, aangeverRapport,partnerRapport]) => {
        this.specBelastingBox3FormGroup.reset();
        if (berekening) {
          this.aangeverBerekening = berekening;
          if (berekening.partnerBerekening) {
            this.partnerBerekening = berekening.partnerBerekening;
          }
        }
        if (incomeTaxEntity) {
          this.getWetgeving()
          this.incomeTaxEntity = incomeTaxEntity;
        if (incomeTaxEntity.aangifte) {
              const aangifte = incomeTaxEntity.aangifte as Aangifte;
              this.aangifte = aangifte;
              this.partner.subscribe((partner) => {
                this.partnerBoolean = partner;
                this.berekeningFormGroup.reset();
                this.specBelastingBox3FormGroup.reset();
          if (partner) {
                    if (partnerRapport.specificatieBox3) {
              this.specBelastingBox3 = partnerRapport;
                      this.specBelastingBox3FormGroup.patchValue(this.specBelastingBox3)
            }
            this.berekening = this.partnerBerekening;
                  this.berekeningFormGroup.patchValue(this.berekening)
          } else {
                  if (aangeverRapport.specificatieBox3) {
              this.specBelastingBox3 = aangeverRapport;
                    this.specBelastingBox3FormGroup.patchValue(this.specBelastingBox3)
            }
            this.berekening = this.aangeverBerekening;
                  this.berekeningFormGroup.patchValue(this.berekening)
                }
              });

          }
        }
      });
  }

  disableFormGroup(formGroup: FormGroup | AbstractControl): void {
    if (formGroup instanceof FormGroup) {
      Object.keys(formGroup.controls).forEach((key) => {
        const control = formGroup.get(key);
        if (control instanceof FormControl) {
          control.disable();
        } else if (control instanceof FormGroup) {
          this.disableFormGroup(control);
        }
      });
    }
  }


}
